// extracted by mini-css-extract-plugin
export default {"dashCard":"styles_dashCard__PFuTw","title":"styles_title__icsx1","card":"styles_card__JRyOn","value":"styles_value__lOAQf"};